query GetDealProducts($hubspotId: Long!) {
    getDeal(hubspotId: $hubspotId) {
        id
        products {
            id
            productId
            installLocationId
            quantity
            features
            previewImage {
                url
            }
        }
    }
}
